import React, { useState } from 'react';
import { AudioRecorder } from './components/AudioRecorder';
import { TranscriptionDisplay } from './components/TranscriptionDisplay';
import { DeepSeekService } from './services/deepseekService';
import './styles/global.css';

function App() {
  const [transcription, setTranscription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const deepseekService = new DeepSeekService();

  const handleTranscription = async (audioBlob) => {
    setIsLoading(true);
    try {
      // Transcrever áudio
      const rawTranscription = await deepseekService.transcribeAudio(audioBlob);
      
      // Formatar com modelo médico
      const formatted = await deepseekService.formatTranscription(rawTranscription.text);
      
      setTranscription(formatted);
    } catch (error) {
      console.error('Transcription error:', error);
      alert('Erro ao processar transcrição. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>Transcritor Médico IA</h1>
        <p>Grave e transcreva consultas médicas automaticamente</p>
      </header>
      
      <main className="app-main">
        <section className="recorder-section">
          <h2>Gravação de Consulta</h2>
          <AudioRecorder onTranscriptionComplete={handleTranscription} />
        </section>
        
        <section className="transcription-section">
          <TranscriptionDisplay 
            transcription={transcription} 
            isLoading={isLoading} 
          />
        </section>
      </main>
    </div>
  );
}

export default App;
